module.exports = {"451226100":"思恩镇","451226101":"水源镇","451226102":"洛阳镇","451226103":"川山镇","451226104":"明伦镇","451226105":"东兴镇","451226200":"大才乡","451226202":"下南乡","451226204":"大安乡","451226205":"长美乡","451226206":"龙岩乡","451226207":"驯乐苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451226.json
// module id = 1989
// module chunks = 0